export class Stats {
    watchDomChanges = 0;
}


// WEBPACK FOOTER //
// ./2sxc-api/js/Stats.ts